const STORAGE_KEY = "innerMap.session.v1";

/**
 * Wraps sessionStorage defensively: private-browsing modes and quota limits
 * can make it throw. A storage failure must never block the experience —
 * it just means the session won't survive a reload.
 */
export function loadSession<T>(): T | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function saveSession<T>(state: T): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // ignore — see module doc
  }
}

export function clearSession(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
